import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://fvnuxqgzkeghaimgqqcz.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZ2bnV4cWd6a2VnaGFpbWdxcWN6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzYxMzc0OTYsImV4cCI6MjA5MTcxMzQ5Nn0.Con9CYC6aXQJJC-vWsYi_p1KyfwJMoTmjcwPEl2OuGs'

export const supabase = createClient(supabaseUrl, supabaseKey)